module.exports = __webpack_public_path__ + "bb8d3a7e11d59216fdab3080f30c1e47.png";


//////////////////
// WEBPACK FOOTER
// ../images/icons/paper_airplane.png
// module id = 2728
// module chunks = 69